import React from 'react';

import styles from './cookieBannerPanel.scss';

interface CookieBannerPanelProps {
  children: React.ReactNode;
}

const CookieBannerPanel = ({
  children
}: CookieBannerPanelProps) => <div className={styles.wrapper}>{children}</div>;

export default CookieBannerPanel;
